import Vue from 'vue'
import beefinx from '@/common/vue/beefinx'

Vue.use(beefinx)
